import AuthenticatedRoute from 'eflex/util/authenticated-route';

export default class CodesRejectRoute extends AuthenticatedRoute {}

